import { IRELAND, UNITED_KINGDOM } from '@nxsys/store/constants/keys';

export const labelIreland = {
  postCode: 'EIR Code',
  UTRNo: 'TRN Number',
  NINo: 'PPS Number',
};

export const labelUK = {
  postCode: 'Post Code',
  UTRNo: 'UTR Number',
  NINo: 'NI Number',
};

export const getFieldLabelByCountry = (country: string, field: string) => {
  switch (country) {
    case IRELAND:
      return labelIreland[field as keyof typeof labelIreland] || field;
    case UNITED_KINGDOM:
      return labelUK[field as keyof typeof labelUK] || field;
    default:
      return labelUK[field as keyof typeof labelUK] || field;
  }
};
